import { dashboardEpic as epic } from './epics'
import { dashboardReducer as reducer } from './reducer'

export const dashboardEpic = epic
export const dashboardReducer = reducer
